module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ae64635916e1ddc8b0ac6bfd73c5cdf1.png";